import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { PageTemplateBody } from '@sierralabs/core-ui';
import CheckIcon from '@material-ui/icons/Check';
const StyledDiv = styled.div `
  width: 100%;
  padding-bottom: 24px;
  padding-top: 32px;
  .section {
    display: flex;
    flex-direction: column;
    max-width: 768px;
    margin: 0 auto 25px auto;
  }
  del {
    display: inline;
    background: #ffbdad;
    padding: 3px 2px;
  }
  ins {
    display: inline;
    background: #abf5d3;
    padding: 3px 2px;
    text-decoration: none;
  }
  .insert {
    background: #abf5d3;
  }
`;
const columnChanges = [
    {
        latest: { name: 'birthDate', type: 'date', nullable: false },
        previous: { name: 'birthDate', type: 'timestamp', nullable: false }
    },
    {
        latest: { name: 'gender', type: 'string', nullable: false },
        previous: { name: 'sex', type: 'string', nullable: true }
    }
];
// const templateChanges = [
//   {
//     latest: { name: '' },
//     previous: { name: 'Patient Info' }
//   }
// ];
export const FormChangesTab = () => {
    return (React.createElement(PageTemplateBody, null,
        React.createElement(StyledDiv, { className: 'form-changes' },
            React.createElement("div", { className: 'section' },
                React.createElement(Typography, { variant: 'overline' }, "Data Schema Changes"),
                React.createElement(Paper, { className: 'section-card' },
                    React.createElement(TableContainer, null,
                        React.createElement(Table, null,
                            React.createElement(TableHead, null,
                                React.createElement(TableRow, null,
                                    React.createElement(TableCell, null, "Column Name"),
                                    React.createElement(TableCell, null, "Data Type"),
                                    React.createElement(TableCell, { className: 'checkbox-column', align: 'center' }, "PK"),
                                    React.createElement(TableCell, { className: 'checkbox-column', align: 'center' }, "NN"),
                                    React.createElement(TableCell, { className: 'checkbox-column', align: 'center' }, "UQ"),
                                    React.createElement(TableCell, { className: 'checkbox-column', align: 'center' }, "AI"),
                                    React.createElement(TableCell, null, "Default / Expression"))),
                            React.createElement(TableBody, null, columnChanges.map((change, index) => (React.createElement(TableRow, { key: index },
                                React.createElement(TableCell, null, change.latest.name !== change.previous.name ? (React.createElement(React.Fragment, null,
                                    React.createElement("del", null, change.previous.name),
                                    React.createElement("ins", null, change.latest.name))) : (change.latest.name)),
                                React.createElement(TableCell, null, change.latest.type !== change.previous.type ? (React.createElement(React.Fragment, null,
                                    React.createElement("del", null, change.previous.type),
                                    React.createElement("ins", null, change.latest.type))) : (change.latest.type)),
                                React.createElement(TableCell, { className: 'checkbox-column', align: 'center', padding: 'checkbox' }),
                                React.createElement(TableCell, { className: 'checkbox-column', align: 'center', padding: 'checkbox' }, change.latest.nullable !== change.previous.nullable ? (React.createElement(CheckIcon, { className: 'insert' })) : (change.latest.nullable && React.createElement(CheckIcon, null))),
                                React.createElement(TableCell, { className: 'checkbox-column', align: 'center', padding: 'checkbox' }),
                                React.createElement(TableCell, { className: 'checkbox-column', align: 'center', padding: 'checkbox' }),
                                React.createElement(TableCell, { className: 'default input-column' }))))))))),
            React.createElement("div", { className: 'section' },
                React.createElement(Typography, { variant: 'overline' }, "Form Template Changes"),
                React.createElement(Paper, { className: 'section-card' },
                    React.createElement(TableContainer, null,
                        React.createElement(Table, null,
                            React.createElement(TableHead, null,
                                React.createElement(TableRow, null,
                                    React.createElement(TableCell, null, "Question"),
                                    React.createElement(TableCell, null, "Description"),
                                    React.createElement(TableCell, null, "Configuration"))),
                            React.createElement(TableBody, null,
                                React.createElement(TableRow, null,
                                    React.createElement(TableCell, null, "Gender"),
                                    React.createElement(TableCell, null, "Select your gender"),
                                    React.createElement(TableCell, null,
                                        React.createElement("del", null, "M"),
                                        React.createElement("ins", null, "Male"),
                                        React.createElement("br", null),
                                        React.createElement("del", null, "F"),
                                        React.createElement("ins", null, "Female"),
                                        React.createElement("br", null),
                                        React.createElement("ins", null, "Other"),
                                        React.createElement("br", null)))))))))));
};
export default FormChangesTab;
//# sourceMappingURL=FormChangesTab.js.map